import { createRoot } from "react-dom/client";

// third party
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { sentryConfig } from "shared/utils/logger";
// project imports
import App from "App";
import { store, persistor } from "store";
import * as serviceWorker from "serviceWorker";
import reportWebVitals from "reportWebVitals";

// style + assets
import "shared/assets/scss/style.css";

// map
import "mapbox-gl/dist/mapbox-gl.css";

// google-fonts
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/700.css";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";


sentryConfig(import.meta.env.VITE_SENTRY_DSN);


const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
